import { useCallback } from 'react';
import { useLocalStorageState } from '@/hooks/useLocalStorageState';

export default function useGlobalModel() {
  // 用 useLocalStorageState 管理时区
  const [timezone, setTimezone] = useLocalStorageState('app-timezone', {
    defaultValue: 'Asia/Tokyo',
  });

  // 用 useLocalStorageState 管理主题
  const [theme, setTheme] = useLocalStorageState('app-theme', {
    defaultValue: 'light',
  });

  // 主题切换
  const toggleTheme = useCallback(() => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  }, [theme, setTheme]);

  return {
    // 状态
    theme,
    timezone,
    
    // 主题操作
    toggleTheme,
    setTheme,
    
    // 时区操作
    setTimezone,
  };
}
